<form
  #jobForm="ngForm"
  class="job-edit"
  (ngSubmit)="submitJob()"
  *ngIf="job">
  <div
    *ngIf="isReadOnly$ | async"
    data-cy="read-only-owner-hint"
    class="card-box warning-card">
    <div>
      <div>
        {{ "readOnlyOwnerAccessHint" | i18n }}
      </div>
      <div>
        {{ ("createdBy" | i18n) + ": " + job.customer.displayName }}
      </div>
    </div>
  </div>
  <div
    *ngIf="job.status === jobStatusEnum.CANCELED"
    data-cy="job-canceled-hint"
    class="card-box warning-card">
    <div>
      {{
        job.canceledAt
          ? (("canceledAt" | i18n) || "Storniert am") +
            " " +
            (job.canceledAt * 1000 | date: "dd.MM.yyyy HH:mm")
          : ("canceled" | i18n) || "Storniert"
      }}
      <div *ngIf="job.cancelReason">
        {{
          (("cancelReason" | i18n) || "Storniergrund:") +
            " " +
            job.cancelReason.displayName[lang] +
            (job.cancelReasonDescription
              ? "\n" + job.cancelReasonDescription
              : "")
        }}
      </div>
      <div *ngIf="cancelUser">
        {{
          (("canceledBy" | i18n) || "Storniert von") +
            " " +
            cancelUser.firstName +
            " " +
            cancelUser.lastName
        }}
      </div>
    </div>
  </div>
  <div
    *ngIf="job.perigonMappingIncomplete"
    data-cy="job-perigon-mapping-incomplete-hint"
    class="card-box warning-card">
    <div>
      {{
        job.pergionMappingIncompleteNotifiedAt
          ? (("perigonMappingIncompleteAt" | i18n) ||
              "Perigon-Zuordnung unvollständig seit") +
            " " +
            (job.pergionMappingIncompleteNotifiedAt * 1000 | date: "short")
          : ("perigonMappingIncomplete" | i18n) ||
            "Perigon-Zuordnung unvollständig"
      }}
      <div *ngIf="'perigonMappingIncompleteDescription' | i18n">
        {{ "perigonMappingIncompleteDescription" | i18n }}
      </div>
    </div>
  </div>
  <div
    *ngIf="job.requestRetractionRequestedAt"
    data-cy="job-request-retraction-requested-hint"
    class="card-box warning-card flex-wrap">
    <div>
      {{
        "requestRetractionRequestedAt"
          | i18n
            : {
                firstName: job.requestRetractionRequestedBy?.firstName || "",
                lastName: job.requestRetractionRequestedBy?.lastName || "",
                date:
                  (job.requestRetractionRequestedAt * 1000
                    | date: "dd.MM.yyyy HH:mm") +
                  (" (" +
                    (job.requestRetractionRequestedAt * 1000
                      | convertToDateObject
                      | formatDistance) +
                    ")")
              }
      }}
    </div>
    <div class="request-retraction-buttons">
      <button
        class="outline-pill-button"
        type="button"
        (click)="clearRequestRetraction($event, false)"
        data-cy="reject-retraction-on-request-button">
        <mat-icon svgIcon="do_not_disturb_on"></mat-icon>
        {{ ("decline" | i18n) || "Ablehnen" | titlecase }}
      </button>
      <button
        class="outline-pill-button text-error"
        type="button"
        (click)="clearRequestRetraction($event, true)"
        data-cy="approve-retraction-on-request-button">
        <mat-icon svgIcon="close"></mat-icon>
        {{ ("accept" | i18n) || "Akzeptieren" | titlecase }}
      </button>
    </div>
  </div>
  <div
    *ngIf="jobInPast && job.status === jobStatusEnum.OPEN"
    class="card-box warning-card"
    data-cy="job-in-past-warning">
    <mat-icon svgIcon="alert-outline"></mat-icon>
    <div class="warning-card-icon-text">
      {{
        ("jobInPastWarning.0" | i18n) ||
          "Dieser Dienst liegt in der Vergangenheit. Bitte beachten:"
      }}
      <ul>
        <li>
          {{
            ("jobInPastWarning.1" | i18n) ||
              "Mitarbeiter können nur sofort gebucht werden"
          }}
        </li>
        <li>
          {{
            ("jobInPastWarning.2" | i18n) ||
              "Es werden keine Benachrichtigung versendet"
          }}
        </li>
        <li>
          {{
            ("jobInPastWarning.3" | i18n) ||
              "Verfügbarkeiten werden nicht berücksichtigt"
          }}
        </li>
      </ul>
    </div>
  </div>
  <ng-container
    *ngIf="
      job.status === jobStatusEnum.OPEN &&
      loggedInCustomer?._id !== job.customer.id
    ">
    <div class="card-box card-box__small">
      <div class="form-row-md-2-cols">
        <app-user-select
          class="light-form-field"
          name="editor"
          [label]="('editor' | i18n) || 'Bearbeiter:in' | titlecase"
          [(ngModel)]="editor"
          [disabled]="!!(isReadOnly$ | async)"
          data-cy="editor-select"
          [filterRole]="roleEnum.DISPO"></app-user-select>
      </div>
    </div>
  </ng-container>
  <div
    class="card-box compressed-main-info"
    *ngIf="showCompressedJobInfo"
    data-cy="compressed-job-info">
    <div class="header-meta">
      <app-job-list-item-date-time
        [job]="job"
        [withDate]="true"></app-job-list-item-date-time>
      <div class="flex-grow"></div>
      <app-job-list-item-counts
        *ngIf="jobCounts$ | async as counts"
        [hidePotentialInviteeCount]="job.status !== jobStatusEnum.OPEN"
        [counts]="counts"></app-job-list-item-counts>
    </div>
    <app-job-list-item-organisation-heading
      class="job-heading"
      [jobType]="job.multiDayId ? 'job-series' : 'job'"
      [department]="job.department"
      [organisation]="
        job.organisation
      "></app-job-list-item-organisation-heading>
    <app-dispo-job-list-item-details-table
      class="details-table"
      [job]="job"></app-dispo-job-list-item-details-table>
    <mat-chip-list *ngIf="organisationTags.length">
      <mat-chip *ngFor="let tag of organisationTags">
        {{ tag.displayName }}
      </mat-chip>
    </mat-chip-list>
    <div class="compressed-view-footer">
      <div
        *ngIf="job?.orderId"
        class="order-id-compressed-view"
        data-cy="job-edit-order-id"
        [matTooltip]="'orderId' | i18n">
        #{{ job.orderId }}
      </div>
      <div
        class="compressed-view-actions"
        *ngIf="!(isReadOnly$ | async)">
        <button
          *ngIf="job.multiDayId"
          class="outline-pill-button icon-left"
          type="button"
          (click)="navigateToMultiDayEdit()"
          data-cy="multiday-edit-button">
          <mat-icon svgIcon="pencil-outline"></mat-icon>
          <span class="mat-fab__label">{{ "multiDayEdit" | i18n }}</span>
        </button>
        <button
          class="outline-pill-button icon-left"
          type="button"
          (click)="showCompressedJobInfo = false"
          data-cy="edit-job-button">
          <mat-icon svgIcon="pencil-outline"></mat-icon>
          <span class="mat-fab__label">{{
            ("edit" | i18n) || "bearbeiten" | titlecase
          }}</span>
        </button>
      </div>
    </div>
  </div>
  <ng-container *ngIf="!showCompressedJobInfo">
    <div class="card-box">
      <div class="form-row-md-2-cols">
        <app-user-select
          class="light-form-field"
          name="editor"
          [label]="('editor' | i18n) || 'Bearbeiter:in' | titlecase"
          [(ngModel)]="editor"
          [disabled]="
            !!(isReadOnly$ | async) ||
            !(isOpenJob$ | async) ||
            loggedInCustomer?.preventChangingOfCreator ||
            false
          "
          [filterRole]="roleEnum.DISPO"></app-user-select>
        <mat-form-field
          *ngIf="loggedInCustomer && loggedInCustomer.branches"
          class="light-form-field">
          <mat-label>{{ ("branch" | i18n) || "branch" | titlecase }}</mat-label>
          <mat-select
            [(ngModel)]="branch"
            required
            name="branch"
            [disabled]="!!(isReadOnly$ | async) || !(isOpenJob$ | async)"
            data-cy="branch-select">
            <mat-option
              *ngFor="let branch of loggedInCustomer.branches"
              [value]="branch.id">
              {{ branch.displayName }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <div class="card-box">
      <div
        class="row"
        *ngIf="user">
        <div
          *ngIf="isOwnedOrganisationJob$ | async"
          class="owned-organisation-job">
          <p class="booked-by-label">
            {{ ("bookedBy" | i18n) || "Gebucht von" }}
            <span>{{ job.customer.displayName }}</span>
          </p>
        </div>
      </div>
      <h1 class="card-title job-card-title">
        {{ ("job" | i18n) || "job" | titlecase }}
        <div
          *ngIf="job?.orderId"
          class="order-id-display"
          data-cy="job-edit-order-id"
          [matTooltip]="'orderId' | i18n">
          #{{ job.orderId }}
        </div>
      </h1>
      <app-job-type-select
        *ngIf="i18n && !loggedInCustomer?.hiddenFields?.jobtype"
        class="light-form-field"
        [selectedJobType]="job.jobType"
        (selectionChanged)="selectJobType($event)"
        [required]="true"
        [lightFormField]="true"
        [disabled]="
          !(canEditJobTypes$ | async) ||
          !isNewJob ||
          !!(criteriaDisabled$ | async) ||
          !!(isReadOnly$ | async) ||
          job.customer?.id !== loggedInCustomer?._id
        "
        data-cy="job-edit-job-type-select">
      </app-job-type-select>
      <app-department-select
        class="light-form-field"
        [label]="
          ('organisationAndDepartment' | i18n) || 'Organisation, Abteilung'
            | titlecase
        "
        (departmentSelectionChanged)="selectDepartment($event, true)"
        [selectedDepartmentId]="selectedDepartmentId || ''"
        [valid]="!!job.department"
        [autoSelectOnlyDepartment]="true"
        [disabled]="
          !isNewJob ||
          hasAvailableOrAcceptedInvitees ||
          job.customer?.id !== loggedInCustomer?._id
        "
        [required]="true"></app-department-select>

      <div
        *ngIf="job.department && organisationTags.length"
        class="form-tags-list">
        <mat-chip-list>
          <mat-chip *ngFor="let tag of organisationTags">
            {{ tag.displayName }}
          </mat-chip>
        </mat-chip-list>
      </div>
      <app-date-ranges-input
        [showValidation]="jobForm.form.dirty"
        [dateRanges]="dateRanges"
        [isDisabled]="!!(datePickerDisabled$ | async)"
        (dateRangesChanged)="dateRangesChanged($event)"></app-date-ranges-input>
      <ng-container *ngIf="availableShifts$ | async as availableShifts">
        <app-job-shifts
          *ngIf="
            (availableShifts && availableShifts.length > 0) ||
            (job.shifts && job.shifts.length > 0)
          "
          [(shifts)]="job.shifts"
          (shiftsChange)="selectShift()"
          [hasMultipleShifts]="hasMultipleShifts"
          (hasMultipleShiftsChange)="toggleHasMultipleShifts($event)"
          [availableShifts]="availableShifts"
          [isNewJob]="isNewJob"
          [canEditShifts]="!!(canEditShifts$ | async)"
          [hasAvailableOrAcceptedInvitees]="hasAvailableOrAcceptedInvitees"
          [invalid]="submitted && (!job.shifts || job.shifts.length === 0)"
          (shiftSelected)="selectShift()"
          data-cy="job-edit-shifts">
        </app-job-shifts>
      </ng-container>
      <div
        *ngIf="noShiftsForWeekDaysHintVisible$ | async"
        data-cy="demo-duration-hint"
        class="card-box hint-card">
        {{
          ("noShiftsForWeekDaysHint" | i18n) ||
            "Keine Schichten für diesen Wochentag verfügbar"
        }}
      </div>
      <div
        *ngIf="noShiftsForJobTypeHintVisible$ | async"
        data-cy="no-shifts-for-job-type-hint"
        class="card-box hint-card">
        {{
          ("noShiftsForJobTypeHint" | i18n) ||
            "Keine Schichten für diese Dienstart verfügbar"
        }}
      </div>
      <div
        *ngIf="noShiftsAvailableHintVisible$ | async"
        data-cy="no-shifts-available-hint"
        class="card-box hint-card">
        {{
          ("noShiftsAvailableHint" | i18n) ||
            "Keine Schichten für diese Abteilung konfiguriert"
        }}
      </div>
      <mat-form-field
        *ngIf="!loggedInCustomer?.hiddenFields?.jobCaseNumber"
        class="light-form-field">
        <mat-label>{{ ("caseNumber" | i18n) || "Case number" }}</mat-label>
        <input
          matInput
          [(ngModel)]="job.caseNumber"
          name="caseNumber"
          [disabled]="
            job.status === jobStatusEnum.CLOSED ||
            job.status === jobStatusEnum.ARCHIVED ||
            job.status === jobStatusEnum.CANCELED ||
            !!(isReadOnly$ | async) ||
            loggedInCustomer?._id !== job.customer?.id
          "
          data-cy="case-number-input" />
      </mat-form-field>
      <mat-form-field
        *ngIf="job.department?.costCenter"
        class="light-form-field">
        <mat-label>{{ ("costCenter" | i18n) || "Kostenstelle" }}</mat-label>
        <input
          matInput
          [ngModel]="job.department.costCenter"
          name="costCenter"
          disabled
          data-cy="cost-center-input" />
      </mat-form-field>
      <mat-form-field
        *ngIf="!loggedInCustomer?.hiddenFields?.jobDescription"
        class="light-form-field">
        <mat-label>{{
          ("description" | i18n) || "description" | titlecase
        }}</mat-label>
        <textarea
          matInput
          [placeholder]="('description' | i18n) || 'description' | titlecase"
          [(ngModel)]="job.description"
          [disabled]="
            job.status === jobStatusEnum.ARCHIVED ||
            job.status === jobStatusEnum.CANCELED ||
            job.customer?.id !== loggedInCustomer?._id ||
            !!(isReadOnly$ | async)
          "
          name="description"
          rows="7"
          data-cy="description-input">
        </textarea>
      </mat-form-field>
    </div>
  </ng-container>
  <div
    class="job-edit"
    *ngIf="job">
    <div
      class="card-box"
      *ngIf="
        (hasTransferredExternal$ | async) ||
        !loggedInCustomer?.hiddenFields?.jobSex ||
        !loggedInCustomer ||
        !loggedInCustomer?.hiddenFields?.jobCertificates ||
        !loggedInCustomer?.hiddenFields?.jobSpecialities ||
        !loggedInCustomer?.hiddenFields?.jobMobility ||
        !loggedInCustomer?.hiddenFields?.jobLanguage
      ">
      <h1 class="card-title">
        {{ ("criteria" | i18n) || "Kriterien" | titlecase }}
      </h1>
      <div class="form-row-md-2-cols">
        <ng-container *ngIf="hasTransferredExternal$ | async">
          <div class="col-md-12">
            <p class="card-hint-text">
              {{
                ("disabledBecauseExternalTransfer" | i18n) ||
                  "Die Kriterien anpassung ist deaktiviert, weil der Dienst an externe Vermittler transferiert wurde."
              }}
            </p>
          </div>
          <div class="col-md-12"></div>
        </ng-container>
        <app-sex-select
          *ngIf="!loggedInCustomer?.hiddenFields?.jobSex"
          class="light-form-field"
          [ngModel]="
            transferToMe?.criteria && transferToMe?.criteria?.sex !== undefined
              ? transferToMe?.criteria?.sex
              : job.sex
          "
          (ngModelChange)="selectSex($event)"
          name="sexSelect"
          [disabled]="(criteriaDisabled$ | async) || !!(isReadOnly$ | async)"
          data-cy="job-sex-select">
          <ng-template #hint>
            <span
              *ngIf="
                transferToMe &&
                transferToMe?.criteria !== undefined &&
                transferToMe?.criteria?.sex !== undefined &&
                transferToMe?.criteria?.sex !== job.sex
              ">
              {{ ("originally" | i18n) || "Ursprünglich" | titlecase }}:
              <span *ngIf="job.sex === sexEnum.FEMALE">
                {{ ("femaleSex" | i18n) || "female" | titlecase }}
              </span>
              <span *ngIf="job.sex === sexEnum.MALE">
                {{ ("maleSex" | i18n) || "male" | titlecase }}
              </span>
              <span *ngIf="job.sex === undefined || job.sex === null">
                {{ ("empty" | i18n) || "nicht definiert" | titlecase }}
              </span>
            </span>
          </ng-template>
        </app-sex-select>
        <div *ngIf="!loggedInCustomer?.hiddenFields?.jobSex"></div>
        <app-certificate-select
          *ngIf="
            !loggedInCustomer ||
            !loggedInCustomer?.hiddenFields?.jobCertificates
          "
          class="light-form-field"
          [selectedMappedCertificates]="
            transferToMe?.criteria?.certificates
              ? transferToMe?.criteria?.certificates || []
              : job.certificates || []
          "
          [disabled]="
            !(isOpenJob$ | async) ||
            !!(isReadOnly$ | async) ||
            (!!(hasTransferredExternal$ | async) && !job.certificates?.length)
          "
          [required]="
            loggedInCustomer?.requiredJobFields?.certificates || false
          "
          [addOnly]="!!(hasTransferredExternal$ | async)"
          [showHint]="
            (transferToMe?.criteria?.certificates &&
              (transferToMe?.criteria?.certificates?.length ||
                job?.certificates?.length) &&
              (job.certificates?.length !==
                transferToMe?.criteria?.certificates?.length ||
                job.certificates?.length !== certificateSet.size)) ||
            false
          "
          (selectionChanged)="certificatesSelected($event)">
          <ng-container slot="hint">
            <div
              class="input-hint"
              [attr.title]="certificatesString">
              {{ ("originally" | i18n) || "Ursprünglich" | titlecase }}:
              <span *ngFor="let cerificate of job.certificates; let i = index">
                {{ cerificate.displayName }}
                {{ i !== (job.certificates?.length || 0) - 1 ? ", " : "" }}
              </span>
              <span *ngIf="!job.certificates?.length">
                {{ ("empty" | i18n) || "nicht definiert" | titlecase }}
              </span>
            </div>
          </ng-container>
        </app-certificate-select>
        <app-speciality-select
          *ngIf="
            !loggedInCustomer ||
            !loggedInCustomer?.hiddenFields?.jobSpecialities
          "
          class="light-form-field"
          [selectedMappedSpecialities]="
            transferToMe?.criteria?.specialities
              ? transferToMe?.criteria?.specialities || []
              : job.specialities || []
          "
          [disabled]="(criteriaDisabled$ | async) || !!(isReadOnly$ | async)"
          [showHint]="
            (transferToMe?.criteria?.specialities &&
              (transferToMe?.criteria?.specialities?.length ||
                job?.specialities?.length) &&
              (job.specialities?.length !==
                transferToMe?.criteria?.specialities?.length ||
                job.specialities?.length !== specialitySet.size)) ||
            false
          "
          (selectionChanged)="specialitiesSelected($event)">
          <ng-container slot="hint">
            <div
              class="input-hint"
              [attr.title]="specialityString">
              {{ ("originally" | i18n) || "Ursprünglich" | titlecase }}:
              <span *ngFor="let speciality of job.specialities; let i = index">
                {{ speciality.displayName }}
                {{ i !== (job.specialities?.length || 0) - 1 ? ", " : "" }}
              </span>
              <span *ngIf="!job.specialities?.length">
                {{ ("empty" | i18n) || "nicht definiert" | titlecase }}
              </span>
            </div>
          </ng-container>
        </app-speciality-select>
        <app-mobility-select
          *ngIf="!loggedInCustomer?.hiddenFields?.jobMobility"
          class="light-form-field"
          data-cy="job-mobility-select"
          [ngModel]="
            transferToMe?.criteria && transferToMe?.criteria?.car !== undefined
              ? transferToMe?.criteria?.car
              : job.car
          "
          (ngModelChange)="selectMobility($event)"
          name="carSelect"
          [disabled]="(criteriaDisabled$ | async) || !!(isReadOnly$ | async)">
          <ng-template #hint>
            <span
              *ngIf="
                transferToMe &&
                transferToMe?.criteria !== undefined &&
                transferToMe?.criteria?.car !== undefined &&
                transferToMe?.criteria?.car !== job.car
              ">
              {{ ("originally" | i18n) || "Ursprünglich" | titlecase }}:
              <span *ngIf="job.car === carLicenseEnum.LICENSE_AVAILABLE">
                {{ ("carLicenseEnum.0" | i18n) || "Fahrausweis" | titlecase }}
              </span>
              <span
                *ngIf="job.car === carLicenseEnum.CAR_AND_LICENSE_AVAILABLE">
                {{
                  ("carLicenseEnum.1" | i18n) || "Auto und Fahrausweis"
                    | titlecase
                }}
              </span>
              <span *ngIf="job.car === undefined || job.car === null">
                {{ ("empty" | i18n) || "Leer" | titlecase }}
              </span>
            </span>
          </ng-template>
        </app-mobility-select>
        <app-language-select
          *ngIf="!loggedInCustomer?.hiddenFields?.jobLanguage"
          class="light-form-field"
          [ngModel]="
            transferToMe?.criteria &&
            transferToMe?.criteria?.language !== undefined
              ? transferToMe?.criteria?.language
              : job.language
          "
          (ngModelChange)="selectLanguage($event)"
          name="languageSelect"
          [disabled]="!!(criteriaDisabled$ | async) || !!(isReadOnly$ | async)">
          <ng-template #hint>
            <span
              *ngIf="
                transferToMe &&
                transferToMe?.criteria !== undefined &&
                transferToMe?.criteria?.language !== undefined &&
                transferToMe?.criteria?.language !== job.language
              ">
              {{ ("originally" | i18n) || "Ursprünglich" | titlecase }}:
              <span *ngIf="job.language !== undefined">
                {{ ("languageEnum." + job.language | i18n) || "Sprache" }}
              </span>
              <span *ngIf="job.language === undefined || job.language === null">
                {{ ("empty" | i18n) || "nicht definiert" | titlecase }}
              </span>
            </span>
          </ng-template>
        </app-language-select>
        <app-pooler-type-multi-select
          *ngIf="
            loggedInCustomer?.enablePoolerTypes &&
            !loggedInCustomer?.hiddenFields?.jobPoolerTypes
          "
          class="light-form-field"
          [selectedPoolerTypes]="
            transferToMe?.criteria?.poolerTypes
              ? transferToMe?.criteria?.poolerTypes || []
              : isOwnJob(job, loggedInCustomer)
              ? job.poolerTypes || []
              : []
          "
          [disabled]="(criteriaDisabled$ | async) || !!(isReadOnly$ | async)"
          (selectionChanged)="poolerTypesSelected($event)">
        </app-pooler-type-multi-select>
      </div>
    </div>

    <div
      *ngIf="
        loggedInCustomer?.enableInternalDescription ||
        loggedInCustomer?.enableDemandReasons
      "
      class="card-box">
      <h1 class="card-title">
        {{
          ("internalInformation" | i18n) || "Interne Informationen" | titlecase
        }}
      </h1>
      <div class="row">
        <div class="col">
          <p class="card-hint-text">
            {{
              "internalInformationSubline"
                | i18n: { customerName: loggedInCustomer?.name || "" }
            }}
          </p>
        </div>
      </div>
      <div
        class="row"
        *ngIf="loggedInCustomer?.enableInternalDescription">
        <div class="col">
          <mat-form-field
            class="light-form-field"
            *ngIf="!loggedInCustomer?.hiddenFields?.jobDescription">
            <mat-label>{{
              ("internalDescription" | i18n) || "interne beschreibung"
                | titlecase
            }}</mat-label>
            <textarea
              matInput
              [placeholder]="
                ('internalDescription' | i18n) || 'interne beschreibung'
                  | titlecase
              "
              [(ngModel)]="customerInternalInformation.description"
              name="internalDescription"
              rows="3"
              data-cy="internal-description-input">
            </textarea>
          </mat-form-field>
        </div>
      </div>
      <div
        class="row"
        *ngIf="loggedInCustomer && loggedInCustomer?.enableDemandReasons">
        <div class="col">
          <mat-form-field class="light-form-field">
            <mat-label>{{ ("reason" | i18n) || "Grund" }}:</mat-label>
            <mat-select
              [(ngModel)]="demandReasonId"
              (selectionChange)="selectDemandReason($event.value)"
              [required]="
                loggedInCustomer?.requiredJobFields?.demandReason || false
              "
              [disabled]="
                (criteriaDisabled$ | async) || !!(isReadOnly$ | async)
              "
              name="internalCreationReason"
              data-cy="internal-creation-reason-select">
              <ng-container
                *ngFor="let reason of loggedInCustomer.demandReasons">
                <mat-option [value]="reason.id">
                  {{ reason.displayName | titlecase }}
                </mat-option>
              </ng-container>
            </mat-select>
          </mat-form-field>
          <mat-form-field
            *ngIf="customerInternalInformation.demandReason?.enableDescription">
            <textarea
              matInput
              [placeholder]="
                ('description' | i18n) || 'beschreibung' | titlecase
              "
              [(ngModel)]="customerInternalInformation.demandReasonDescription"
              name="internalCreationReasonDescription"
              rows="2"
              data-cy="internal-creation-reason-description-input">
            </textarea>
          </mat-form-field>
        </div>
      </div>
    </div>
    <div
      *ngIf="loggedInCustomer?.customCriteria?.length"
      class="card-box">
      <h1 class="card-title">
        {{ "customCriteria" | i18n | titlecase }}
      </h1>
      <div
        class="row mb-2"
        *ngFor="
          let customCriteria of loggedInCustomer!.customCriteria!;
          trackBy: trackByCustomCriteriaId
        ">
        <div class="col">
          <ng-container
            *ngIf="customCriteria.type === customCriteriaTypeEnum.TOGGLE">
            <mat-slide-toggle
              class="custom-criteria-job-toggle"
              [(ngModel)]="jobToggleCriterion(customCriteria.id).value"
              (ngModelChange)="jobCustomCriteriaChanged()"
              [name]="'job-custom-crit-toggle-' + customCriteria.id"
              [attr.data-cy]="'job-custom-crit-toggle-' + customCriteria.id"
              [disabled]="
                (criteriaDisabled$ | async) || !!(isReadOnly$ | async)
              ">
              {{ customCriteria.displayName }}
            </mat-slide-toggle>
          </ng-container>
          <mat-form-field
            *ngIf="customCriteria.type === customCriteriaTypeEnum.SELECT"
            class="light-form-field w-100">
            <mat-label>{{ customCriteria.displayName | titlecase }}</mat-label>
            <mat-select
              *ngIf="customCriteria.multiple"
              multiple
              [compareWith]="compareCustomCriteriaOption"
              [(ngModel)]="jobSelectCriterion(customCriteria.id).values"
              (ngModelChange)="jobCustomCriteriaChanged()"
              [name]="'job-custom-crit-select-multi-' + customCriteria.id"
              [attr.data-cy]="
                'job-custom-crit-select-multi-' + customCriteria.id
              "
              [disabled]="
                (criteriaDisabled$ | async) || !!(isReadOnly$ | async)
              ">
              <mat-option
                *ngFor="let option of customCriteria.options"
                [value]="option">
                {{ option.displayName }}
              </mat-option>
            </mat-select>
            <mat-select
              *ngIf="!customCriteria.multiple"
              [compareWith]="compareCustomCriteriaOption"
              [ngModel]="
                getJobSingleSelectValue(
                  $any(
                    customerInternalInformation.customCriteria![
                      customCriteria.id
                    ]
                  )
                )
              "
              (ngModelChange)="
                setJobSingleSelectValue(
                  $any(
                    customerInternalInformation.customCriteria![
                      customCriteria.id
                    ]
                  ),
                  $event
                );
                jobCustomCriteriaChanged()
              "
              [name]="'job-custom-crit-select-single-' + customCriteria.id"
              [attr.data-cy]="
                'job-custom-crit-select-single-' + customCriteria.id
              "
              [disabled]="
                (criteriaDisabled$ | async) || !!(isReadOnly$ | async)
              ">
              <mat-option
                *ngFor="let option of customCriteria.options"
                [value]="option">
                {{ option.displayName }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </div>

    <div class="card-box">
      <h1 class="card-title">
        {{ ("employees" | i18n) || "Mitarbeiter" | titlecase }}
      </h1>
      <div
        class="row"
        *ngIf="!multiDay">
        <div class="col-3">
          <mat-form-field class="light-form-field">
            <mat-label>{{
              ("requiredEmployees" | i18n) || "Benötigte Mitarbeiter"
            }}</mat-label>
            <input
              required
              matInput
              [ngModel]="job.requiredUsers || 1"
              (ngModelChange)="job.requiredUsers = $event"
              [readonly]="
                (!isNewJob &&
                  !(isOpenJob$ | async) &&
                  !(canEditRequiredUsersOnClosedJob$ | async)) ||
                (job.customer?.id || loggedInCustomer?._id) !==
                  loggedInCustomer?._id
              "
              [disabled]="!!(requiredEmployeesDisabled$ | async)"
              name="requiredEmployees"
              type="number"
              [min]="(acceptedUsers | async)?.length || 1"
              max="1000"
              [required]="false"
              data-cy="required-employees-input" />
          </mat-form-field>
        </div>
        <div class="col-sm-9">
          <mat-form-field class="light-form-field">
            <mat-label>{{ ("name" | i18n) || "Name" }}</mat-label>
            <input
              data-cy="possible-user-list-search"
              matInput
              name="userSearch"
              [(ngModel)]="userSearch"
              (ngModelChange)="updatePossibleUsersSearch()" />
          </mat-form-field>
        </div>
      </div>
      <div data-cy="job-edit-invitees-list">
        <div
          *ngIf="!loadingJob && !loadingUsers && job.invitees?.length"
          class="requested-employees-list">
          <h3 class="card-sub-title">
            {{
              ("requestedEmployees" | i18n) || "requested employees" | titlecase
            }}
          </h3>
          <app-job-invitee-list
            [job]="job"
            [invitees]="job.invitees"
            [loggedInUser]="user"
            [jobCustomer]="(customerOfJob$ | async) || undefined"
            [nameSearch]="userSearch">
          </app-job-invitee-list>
        </div>
      </div>
      <div
        class="available-employees-list single-day"
        data-cy="available-employees-list"
        *ngIf="
          !(isSharedJob$ | async) &&
          !(isReadOnly$ | async) &&
          (isOpenJob$ | async) &&
          !multiDay &&
          finishedLoadingQueryParams
        ">
        <ng-container *ngIf="!loadingUsers">
          <h3 class="card-sub-title">
            {{
              ("availableEmployees" | i18n) || "verfügbare Mitarbeiter"
                | titlecase
            }}
          </h3>
          <app-job-possible-users-list
            *ngIf="loggedInCustomer"
            #availableUsers
            [loadingCollection]="loadingUsers"
            [collection]="possibleUsers"
            [suggestInsteadDirectAccept]="!!suggestInsteadDirectAccept"
            [directAcceptedUsers]="directAcceptUsers"
            [directInvitedUsers]="selectedUsers"
            [job]="job"
            [jobCustomer]="(customerOfJob$ | async) || undefined"
            [loggedInCustomer]="loggedInCustomer"
            [jobDate]="job.date"
            [jobInPast]="jobInPast"
            (selectAllToggled)="inviteeSelectionToggled($event)"
            (inviteeToggled)="dayInviteeToggled($event)"
            data-cy="job-edit-possible-users"></app-job-possible-users-list>
        </ng-container>
      </div>

      <ng-container *ngIf="isNewJob && multiDay">
        <app-accordion
          *ngFor="let day of multiDays; let i = index"
          class="multiDay-accordion"
          [attr.data-cy]="'multi-day-item-date-' + day.date"
          [collapsed]="day.collapsed"
          (accordionToggled)="day.collapsed = $event">
          <app-accordion-header
            [collapseOnHeaderClick]="day.enabled"
            [displayArrowButton]="day.enabled"
            [attr.data-cy]="'multi-day-accordion-header-' + day.date"
            class="multiDay-accordion-header"
            [class.day-disabled]="!day.enabled">
            <div class="multiDay-toggle">
              <button
                type="button"
                class="outline-pill-button icon-only"
                (click)="toggleDayEnabled(day); $event.stopPropagation()">
                <mat-icon [svgIcon]="day.enabled ? 'minus' : 'plus'"></mat-icon>
              </button>
            </div>
            <div
              class="mutliday-warning"
              *ngIf="
                violationMessagesPerDayUuid.get(day.uuid) as dayViolations
              ">
              <mat-icon
                *ngIf="dayViolations.overlapsMessage.length"
                [matTooltip]="dayViolations.overlapsMessage"
                matTooltipClass="pre-wrap-tooltip"
                class="text-icon-error size-20"
                svgIcon="suitcase-job"></mat-icon>
              <mat-icon
                *ngIf="dayViolations.restViolationsMessage.length"
                [matTooltip]="dayViolations.restViolationsMessage"
                matTooltipClass="pre-wrap-tooltip"
                class="text-icon-error size-20"
                svgIcon="bed"></mat-icon>
            </div>
            <div class="multiDay-wrap-info">
              <div class="multiDay-date">
                {{ day.date | date: "EEEEEE, dd.MM.yyyy" }}
              </div>
              <app-editable-shift-tags
                [isDisabled]="
                  !(canEditShifts$ | async) || !!(criteriaDisabled$ | async)
                "
                [shifts]="day.shifts"
                [jobType]="
                  loggedInCustomer?.hiddenFields?.jobtype
                    ? undefined
                    : day.jobType
                "
                [availableShifts]="day.availableDepartmentShifts"
                (shiftsModified)="
                  editMultiDayShifts(day, $event)
                "></app-editable-shift-tags>
              <div class="flex-spacer"></div>
              <div class="multiDay-selection">
                <div
                  class="invite-users-info"
                  data-cy="invite-users-info"
                  *ngIf="day.inviteUsers.length">
                  {{
                    "inviteXOfYPeople"
                      | i18n
                        : {
                            count: day.inviteUsers.length
                          }
                  }}
                </div>
                <div
                  class="book-users-info"
                  data-cy="book-users-info"
                  *ngIf="day.directAcceptUsers.length">
                  {{
                    "bookXPeopleDirectly"
                      | i18n: { count: day.directAcceptUsers.length }
                  }}
                </div>
              </div>
            </div>
          </app-accordion-header>
          <app-accordion-content
            class="multiDay-accordion-content"
            #accordionContent>
            <ng-container
              *ngIf="
                !(accordionContent.contentCompletelyHidden$ | async) &&
                day.enabled
              ">
              <div class="row multiday-user-search">
                <div class="col-3">
                  <mat-form-field class="light-form-field">
                    <mat-label>{{
                      ("requiredEmployees" | i18n) || "Benötigte Mitarbeiter"
                    }}</mat-label>
                    <input
                      matInput
                      [ngModel]="day.requiredUsers || 1"
                      (ngModelChange)="day.requiredUsers = $event"
                      [readonly]="
                        (!isNewJob &&
                          !(isOpenJob$ | async) &&
                          !(canEditRequiredUsersOnClosedJob$ | async)) ||
                        job.customer?.id !== loggedInCustomer?._id
                      "
                      [disabled]="!!(requiredEmployeesDisabled$ | async)"
                      name="requiredEmployees"
                      type="number"
                      [min]="(acceptedUsers | async)?.length || 1"
                      max="1000"
                      [required]="false"
                      data-cy="required-employees-input" />
                  </mat-form-field>
                </div>
                <div class="col-sm-9">
                  <mat-form-field class="light-form-field">
                    <mat-label>{{ ("name" | i18n) || "Name" }}</mat-label>
                    <input
                      data-cy="possible-user-list-search"
                      matInput
                      name="userSearch"
                      [(ngModel)]="day.userSearch"
                      (ngModelChange)="updateUsersForMultiDay(day)" />
                  </mat-form-field>
                </div>
              </div>
              <div
                class="row available-multiDay-employees-list"
                data-cy="available-employees-list">
                <app-job-possible-users-list
                  *ngIf="loggedInCustomer"
                  #multiDayAvailableUsers
                  [collection]="day.possibleUsers"
                  [loadingCollection]="loadingUsers"
                  (inviteeToggled)="multiDayInviteeToggled($event, day)"
                  [directAcceptedUsers]="day.directAcceptUsers"
                  [directInvitedUsers]="day.inviteUsers"
                  [job]="job"
                  [jobCustomer]="(customerOfJob$ | async) || undefined"
                  [loggedInCustomer]="loggedInCustomer"
                  [jobDate]="day.date"
                  [randomId]="randomId"
                  [jobCount]="enabledJobs"
                  [jobInPast]="day.jobInPast || false"
                  (selectAllToggled)="
                    multiDayInviteeSelectionToggled(day, $event)
                  "
                  [userCount]="userCount"></app-job-possible-users-list>
              </div>
            </ng-container>
          </app-accordion-content>
        </app-accordion>
      </ng-container>

      <div
        class="row"
        *ngIf="
          !(isSharedJob$ | async) &&
          !(isReadOnly$ | async) &&
          (isOpenJob$ | async) &&
          !jobInPast
        ">
        <div class="col">
          <div class="list-final-options">
            <mat-slide-toggle
              [(ngModel)]="undecided"
              labelPosition="before"
              name="toggleUndecided"
              (change)="toggleUndecided($event)"
              data-cy="include-undecided-checkbox">
              {{
                ("includeUndecided" | i18n) || "Include unknown availability"
              }}
            </mat-slide-toggle>
            <mat-slide-toggle
              *ngIf="
                loggedInCustomer?.allowIgnoreUserPreferenceDepartmentBlacklist
              "
              [(ngModel)]="ignoreUserPreferenceDepartmentBlacklist"
              labelPosition="before"
              name="toggleIgnoreUserPreferenceDepartmentBlacklist"
              (change)="toggleIgnoreUserPreferenceDepartmentBlacklist($event)"
              data-cy="ignore-user-preference-department-blacklist-checkbox">
              {{
                ("allowIgnoreUserPreferenceDepartmentBlacklist" | i18n) ||
                  "Abteilungspräferenz der Mitarbeiter Ignorieren"
              }}
            </mat-slide-toggle>
            <ng-container
              *ngIf="
                loggedInCustomer?._id === job?.customer?.id &&
                (loggedInCustomer?.customerTransfers?.transfers?.length ||
                  sharedPoolCustomers?.length) &&
                (user?.dispoPermissions?.dispoAccess?.featurePermissions
                  ?.transferPermissions !== false ||
                  user?.dispoPermissions?.dispoAccess?.featurePermissions
                    ?.sharedPoolPermissions !== false)
              ">
              <mat-slide-toggle
                name="allowExternalInvitees"
                labelPosition="before"
                [(ngModel)]="job.allowExternalInvitees"
                (change)="toggleExternalInvitees()"
                [disabled]="
                  hasTransferred ||
                  hasSharedPoolInvitees ||
                  !!(isReadOnly$ | async)
                "
                data-cy="external-poolers-toggle"
                >{{ "allowExternalPoolers" | i18n }}
              </mat-slide-toggle></ng-container
            >
          </div>
        </div>
      </div>

      <ng-container *ngIf="isNewJob && multiDay">
        <div class="multiDay-selection-buttons">
          <button
            class="outline-pill-button icon-left"
            type="button"
            (click)="clearAllInviteesForAllMultiDays()"
            data-cy="multiday-select-all-button">
            <mat-icon svgIcon="minus"></mat-icon>
            <span class="mat-fab__label">{{
              ("deselectAllEmployees" | i18n) || "Alle Mitarbeitenden Abwählen"
                | titlecase
            }}</span>
          </button>
          <button
            class="outline-pill-button icon-left"
            type="button"
            (click)="selectAllInviteesForAllMultiDays()"
            data-cy="multiday-select-all-button">
            <mat-icon svgIcon="plus"></mat-icon>
            <span class="mat-fab__label">{{
              ("selectAllEmployees" | i18n) || "Alle Mitarbeitenden Auswählen"
                | titlecase
            }}</span>
          </button>
        </div>
      </ng-container>
    </div>
    <div
      class="card-box"
      *ngIf="
        !(isSharedJob$ | async) &&
        job.transfers?.length &&
        user &&
        user?.customerId &&
        user?.dispoPermissions?.dispoAccess?.featurePermissions
          ?.transferPermissions !== false &&
        (hasTransferred || job.status == jobStatusEnum.OPEN) &&
        (job.allowExternalInvitees || job.allowExternalInvitees === undefined)
      "
      data-cy="transfers-section">
      <div class="card-title-row">
        <h1 class="card-title">
          {{ ("transfers" | i18n) || "transfer" | titlecase }}
        </h1>
        <ng-container
          *ngIf="
            job?.customer?.id == user.customerId &&
            (!loggedInCustomer?.customerTransfers?.confirmTransfers ||
              transferConfirmed ||
              hasTransferred)
          ">
          <button
            *ngIf="!isNewJob && !transferredToAll"
            mat-button
            type="button"
            class="transfer-button"
            data-cy="transfer-to-all-button"
            (click)="manualTransferAll()">
            <mat-icon svgIcon="board-mission-transfer-arrow"></mat-icon>
            {{ ("transferToAll" | i18n) || "An alle transferieren" }}
          </button>
          <mat-checkbox
            *ngIf="isNewJob"
            data-cy="direct-transfer-all"
            [checked]="transferAll"
            (change)="directTransferAllCheckboxChange()"
            class="direct-transfer-all-checkbox">
          </mat-checkbox>
        </ng-container>
      </div>
      <ng-container
        *ngIf="
          job?.customer?.id == user.customerId &&
          loggedInCustomer?.customerTransfers?.confirmTransfers &&
          loggedInCustomer?.customerTransfers?.transferConfirmationPersons
            ?.length
        ">
        <div class="transfer-confirmation-area">
          <div>
            <mat-checkbox
              class="new-checkbox-color"
              [(ngModel)]="transferConfirmed"
              (ngModelChange)="transfersConfirmedChange()"
              name="transfersConfirmedCheckbox"
              [disabled]="!selectedTransferConfirmationPerson || hasTransferred"
              data-cy="transfers-confirmed-checkbox">
              {{ ("transfersConfirmed" | i18n) || "Transfers bestätigt" }}
            </mat-checkbox>
          </div>
          <mat-form-field>
            <mat-label>{{
              ("transferConfirmationPerson" | i18n) || "Bestätigungsperson"
            }}</mat-label>
            <mat-select
              [(ngModel)]="selectedTransferConfirmationPerson"
              (selectionChange)="transfersConfirmedChange()"
              name="transferConfirmationPersonSelect"
              [disabled]="hasTransferred"
              data-cy="transfer-confirmation-person-select">
              <mat-option
                *ngFor="
                  let person of loggedInCustomer?.customerTransfers
                    ?.transferConfirmationPersons
                "
                [value]="person">
                {{ person }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </ng-container>
      <div class="transfers-list">
        <ng-container
          *ngFor="
            let transfer of job.transfers;
            let i = index;
            trackBy: trackByTransferTarget
          ">
          <ng-container
            *ngIf="
              !(isReadOnly$ | async) &&
              (job?.customer?.id == user.customerId ||
                transfer.targetCustomer.id == user.customerId)
            ">
            <div
              class="transfers-list-item"
              [attr.data-cy]="
                !transfer.transferredAt
                  ? 'transferable-transfer'
                  : 'transferred-transfer'
              ">
              <ng-container *ngIf="!transfer.transferredAt">
                <div class="transfers-list-item-header">
                  <div class="transfer-target-customer">
                    <mat-icon svgIcon="person-user-arrow-transfer"></mat-icon>
                    <h3 data-cy="transfer-display-name">
                      {{ transfer.targetCustomer.displayName }}
                    </h3>

                    <ng-container *ngIf="transfer.availabilityInfosForAgents">
                      <mat-icon
                        data-cy="availabilityInfosForAgents-icon"
                        class="mx-2 mat-info-icon-pointer"
                        svgIcon="information-outline"
                        (click)="
                          openAgentDialog(
                            transfer.availabilityInfosForAgents,
                            transfer.targetCustomer.displayName
                          )
                        "></mat-icon>
                    </ng-container>
                  </div>
                  <div class="transfer-transfer-action">
                    <div
                      *ngIf="
                        (transfer.auto || transfer.directTransfer) &&
                        transfer.transferAt &&
                        (!transfer.conditionallyBlocked ||
                          transfer.conditionallyBlockedUntil)
                      "
                      class="transfer-auto">
                      <mat-icon
                        svgIcon="board-mission-transfer-auto-star"></mat-icon>
                      <span
                        *ngIf="
                          transfer.auto &&
                          !multiDay &&
                          (!transfer.conditionallyBlocked ||
                            transfer.conditionallyBlockedUntil)
                        ">
                        <ng-container
                          *ngIf="
                            (transfer.transferAt || 0) >
                              (transfer.conditionallyBlockedUntil || 0) ||
                              !transfer.conditionallyBlockedUntil;
                            else transferAfterBlocked
                          ">
                          <ng-container
                            *ngIf="
                              now.getTime() <
                                (
                                  transfer.transferAt * 1000
                                  | convertToDateObject
                                ).getTime();
                              else transferImmediately
                            ">
                            {{
                              "automaticallyAt"
                                | i18n
                                  : {
                                      date:
                                        (transfer.transferAt || 0) * 1000
                                        | convertToDateObject
                                        | displayDate: "dd.MM.yyyy",
                                      distance:
                                        (transfer.transferAt || 0) * 1000
                                        | convertToDateObject
                                        | formatDistance
                                    }
                            }}
                          </ng-container>
                          <ng-template #transferImmediately>
                            {{ "automaticallyImmediately" | i18n }}
                          </ng-template>
                        </ng-container>
                        <ng-template #transferAfterBlocked>
                          {{
                            "automaticallyAfterBlocked"
                              | i18n
                                : {
                                    distance:
                                      (transfer.conditionallyBlockedUntil ||
                                        0) * 1000
                                      | convertToDateObject
                                      | formatDistance
                                  }
                          }}
                        </ng-template>
                      </span>
                      <span
                        *ngIf="
                          transfer.directTransfer && !transfer.auto && !isNewJob
                        ">
                        {{ ("will" | i18n) || "wird" }}
                        {{
                          transfer.transferAt || 0
                            | transferTime
                              : {
                                  showPast: false,
                                  directTransfer: true,
                                  locale: user?.locale,
                                  i18n: i18n
                                }
                        }}
                        {{ ("transferred" | i18n) || "transferiert" }}</span
                      >
                    </div>
                    <ng-container
                      *ngIf="
                        job?.customer?.id === user?.customerId &&
                        !(isReadOnly$ | async) &&
                        (isOpenJob$ | async) &&
                        (!loggedInCustomer?.customerTransfers
                          ?.confirmTransfers ||
                          transferConfirmed ||
                          hasTransferred)
                      ">
                      <button
                        *ngIf="
                          !isNewJob &&
                          !transfer.directTransfer &&
                          !transfer.conditionallyBlocked
                        "
                        mat-button
                        type="button"
                        class="transfer-button"
                        data-cy="transfer-button"
                        (click)="manualTransfer(transfer.targetCustomer)">
                        <mat-icon
                          svgIcon="board-mission-transfer-arrow"></mat-icon>
                        {{ ("transferNow" | i18n) || "Jetzt transferieren" }}
                      </button>
                      <mat-checkbox
                        *ngIf="isNewJob && !transfer.conditionallyBlocked"
                        data-cy="direct-transfer"
                        class="new-checkbox-color"
                        [labelPosition]="'before'"
                        [checked]="transfer.directTransfer || false"
                        (change)="directTransferCheckboxChange(transfer)">
                        {{
                          ("directTransfer" | i18n) || "Direkt Transferieren"
                        }}
                      </mat-checkbox>
                      <div
                        *ngIf="
                          transfer.conditionallyBlocked &&
                          transfer.conditionallyBlockedUntil &&
                          !transfer.auto
                        ">
                        <span
                          >{{ ("blockedUntil" | i18n) || "Gesperrt bis: " }}
                          {{
                            transfer.conditionallyBlockedUntil || 0
                              | transferTime
                                : {
                                    showPast: false,
                                    locale: user?.locale,
                                    i18n: i18n
                                  }
                          }}</span
                        >
                      </div>
                    </ng-container>
                  </div>
                </div>
                <div class="transfers-list-item-body">
                  <div
                    *ngIf="
                      !transfer.directTransfer &&
                      (!transfer.conditionallyBlocked ||
                        transfer.conditionallyBlockedUntil)
                    ">
                    <mat-checkbox
                      class="new-checkbox-color"
                      [checked]="transfer.auto"
                      [disabled]="
                        !!(
                          loggedInCustomer?.customerTransfers
                            ?.confirmTransfers &&
                          !transferConfirmed &&
                          !hasTransferred
                        )
                      "
                      data-cy="auto-transfer"
                      (change)="transferAutoCheckboxChange(i)">
                      <span class="transfer-checkbox">
                        <mat-icon
                          svgIcon="board-mission-transfer-auto-star"></mat-icon>
                        {{
                          ("transferAutomatically" | i18n) ||
                            "Automatisch transferieren"
                        }}
                      </span>
                    </mat-checkbox>
                  </div>
                  <div
                    *ngIf="
                      !transfer.forceDirectAccept &&
                      !transfer.hideDirectAccept &&
                      (!transfer.conditionallyBlocked ||
                        transfer.conditionallyBlockedUntil)
                    ">
                    <mat-checkbox
                      [checked]="!transfer.preventDirectAccept"
                      class="new-checkbox-color"
                      data-cy="allow-direct-accept"
                      (change)="transferPreventDirectAcceptCheckboxChange(i)">
                      <span class="transfer-checkbox">
                        {{
                          ("allowDirectAccept" | i18n) ||
                            "Direktbuchen erlauben"
                        }}
                      </span>
                    </mat-checkbox>
                    <br />
                  </div>
                </div>
              </ng-container>
              <ng-container *ngIf="transfer.transferredAt">
                <div class="transfers-list-item-header">
                  <div class="transfer-target-customer">
                    <mat-icon svgIcon="person-user-arrow-transfer"></mat-icon>
                    <h3
                      data-cy="transfer-display-name"
                      *ngIf="
                        loggedInCustomer &&
                        loggedInCustomer._id == transfer.targetCustomer.id
                      ">
                      {{ job.customer.displayName }}
                    </h3>
                    <h3
                      data-cy="transfer-display-name"
                      *ngIf="
                        loggedInCustomer &&
                        loggedInCustomer._id == job.customer?.id
                      ">
                      {{ transfer.targetCustomer.displayName }}

                      <ng-container *ngIf="transfer.availabilityInfosForAgents">
                        <mat-icon
                          class="mx-2 mat-info-icon-pointer"
                          svgIcon="information-outline"
                          (click)="
                            openAgentDialog(
                              transfer.availabilityInfosForAgents,
                              transfer.targetCustomer.displayName
                            )
                          "></mat-icon>
                      </ng-container>
                    </h3>
                  </div>
                  <div class="transfer-transferred-at">
                    <mat-icon svgIcon="board-mission-transfer-arrow"></mat-icon>
                    <div>
                      {{
                        "transferredAt"
                          | i18n
                            : {
                                date:
                                  transfer.transferredAt * 1000
                                  | convertToDateObject
                                  | displayDate: "dd.MM.yyyy",
                                distance:
                                  transfer.transferredAt * 1000
                                  | convertToDateObject
                                  | formatDistance
                              }
                      }}
                      <span *ngIf="transfer.transferredBy?.firstName">
                        <br />
                        {{ ("by" | i18n) || "von" }}
                        {{
                          transfer.transferredBy?.firstName +
                            " " +
                            transfer.transferredBy?.lastName
                        }}
                      </span>
                    </div>
                  </div>
                  <div
                    *ngIf="transfer.declinedAt && transfer.declinedBy"
                    class="transfer-declined-at">
                    <mat-icon
                      svgIcon="board-mission-transfer-decline-rejected"></mat-icon>
                    <div>
                      {{
                        "declinedAt"
                          | i18n
                            : {
                                date:
                                  transfer.declinedAt * 1000
                                  | convertToDateObject
                                  | displayDate: "dd.MM.yyyy",
                                distance:
                                  transfer.declinedAt * 1000
                                  | convertToDateObject
                                  | formatDistance
                              }
                      }}
                      <span *ngIf="transfer.transferredBy?.firstName">
                        <br />
                        {{ ("by" | i18n) || "von" }}
                        {{
                          transfer.declinedBy?.firstName +
                            " " +
                            transfer.declinedBy?.lastName
                        }}
                      </span>
                    </div>
                  </div>
                </div>
                <div class="transfer-list-item-body">
                  <mat-checkbox
                    *ngIf="
                      !transfer.forceDirectAccept && !transfer.hideDirectAccept
                    "
                    class="new-checkbox-color"
                    [checked]="!transfer.preventDirectAccept"
                    disabled>
                    {{
                      ("allowDirectAccept" | i18n) || "Direktbuchen erlauben"
                    }}
                  </mat-checkbox>
                </div>
              </ng-container>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </div>

    <div
      *ngIf="
        !(isReadOnly$ | async) &&
        ((canClose$ | async) || canCancel || canDecline || canDuplicate)
      "
      class="card-box job-actions">
      <button
        class="outline-pill-button icon-left"
        type="button"
        *ngIf="canClose$ | async"
        (click)="close()"
        data-cy="close-job">
        <mat-icon svgIcon="close"></mat-icon>
        {{ ("conclude" | i18n) || "close" | titlecase }}
      </button>

      <ng-container *ngIf="canDuplicate">
        <button
          class="outline-pill-button icon-left"
          type="button"
          (click)="$event.stopPropagation(); jobService.duplicateJob(job)"
          data-cy="duplicate-job">
          <mat-icon svgIcon="duplicate-copy"></mat-icon>
          {{ ("duplicate" | i18n) || "duplicate" | titlecase }}
        </button>
      </ng-container>

      <ng-container *ngIf="canCancel">
        <button
          class="outline-pill-button icon-left text-error"
          type="button"
          (click)="jobService.startCancelJob(job)"
          data-cy="cancel-job">
          <mat-icon svgIcon="close"></mat-icon>
          {{ ("cancelJob" | i18n) || "cancel job" | titlecase }}
        </button>
      </ng-container>
      <ng-container *ngIf="canDecline">
        <button
          class="outline-pill-button icon-left text-error"
          type="button"
          (click)="declineTransfer()"
          data-cy="decline-job">
          <mat-icon svgIcon="close"></mat-icon>
          {{ ("declineJob" | i18n) || "decline job" | titlecase }}
        </button>
      </ng-container>
    </div>
  </div>
  <div class="floating-actions-bar">
    <button
      class="secondary-pill-button icon-left big-fab"
      (click)="historyBack()"
      type="button">
      <ng-container *ngIf="jobForm.form.dirty">
        <mat-icon svgIcon="arrow-left"></mat-icon>
        <span class="mat-fab__label">
          {{ ("cancel" | i18n) || "abbrechen" | titlecase }}</span
        >
      </ng-container>
      <ng-container *ngIf="!jobForm.form.dirty">
        <mat-icon svgIcon="arrow-left"></mat-icon>
        <span class="mat-fab__label">
          {{ ("back" | i18n) || "zurück" | titlecase }}</span
        >
      </ng-container>
    </button>
    <button
      *ngIf="
        (multiDay || job.date) && job.shifts?.length && hasUnsavedChanges()
      "
      class="primary-pill-button icon-left big-fab"
      type="submit"
      [class.invalid]="
        !jobForm.form.valid ||
        (!selectedDepartment && isNewJob) ||
        (multiDay && !enabledJobs) ||
        !shiftsValid
      "
      data-cy="save-job-button">
      <ng-container
        *ngIf="
          isNewJob &&
          selectedUsers.length === 0 &&
          directAcceptUsers.length === 0 &&
          !multiDayDirectAcceptUsers &&
          !multiDayInviteUsers
        ">
        <mat-icon svgIcon="plus-box-multiple"></mat-icon>
        <span class="mat-fab__label"
          ><span *ngIf="multiDays && enabledJobs">{{ enabledJobs }} </span
          >{{ ("create" | i18n) || "erstellen" | titlecase }}</span
        >
      </ng-container>
      <ng-container
        *ngIf="
          !isNewJob &&
          selectedUsers.length === 0 &&
          directAcceptUsers.length === 0 &&
          !multiDayDirectAcceptUsers &&
          !multiDayInviteUsers
        ">
        <mat-icon svgIcon="save"></mat-icon>
        <span class="mat-fab__label">{{
          ("save" | i18n) || "speichern" | titlecase
        }}</span>
      </ng-container>
      <ng-container
        *ngIf="
          (selectedUsers.length > 0 && directAcceptUsers.length === 0) ||
          (multiDays && !multiDayDirectAcceptUsers && multiDayInviteUsers)
        ">
        <mat-icon svgIcon="send"></mat-icon>
        <span class="mat-fab__label"
          ><span>{{ multiDayInviteUsers || selectedUsers.length }} </span
          >{{ ("invite" | i18n) || "einladen" | titlecase }}</span
        >
      </ng-container>
      <ng-container
        *ngIf="
          (selectedUsers.length === 0 && directAcceptUsers.length > 0) ||
          (multiDays && multiDayDirectAcceptUsers && !multiDayInviteUsers)
        ">
        <mat-icon svgIcon="send"></mat-icon>
        <span class="mat-fab__label"
          ><span *ngIf="!suggestInsteadDirectAccept"
            >{{ multiDayDirectAcceptUsers || directAcceptUsers.length }} </span
          ><span *ngIf="!suggestInsteadDirectAccept">{{
            ("book" | i18n) || "buchen" | titlecase
          }}</span
          ><span *ngIf="suggestInsteadDirectAccept"
            >{{ multiDayDirectAcceptUsers || directAcceptUsers.length }} </span
          ><span *ngIf="suggestInsteadDirectAccept">{{
            ("suggest" | i18n) || "einreichen" | titlecase
          }}</span></span
        >
      </ng-container>
      <ng-container
        *ngIf="
          (selectedUsers.length > 0 && directAcceptUsers.length > 0) ||
          (multiDays && multiDayDirectAcceptUsers && multiDayInviteUsers)
        ">
        <mat-icon svgIcon="send"></mat-icon>
        <span class="mat-fab__label">
          <ng-container *ngIf="!suggestInsteadDirectAccept">
            {{
              "inviteAndBook"
                | i18n
                  : {
                      inviteCount: multiDayInviteUsers || selectedUsers.length,
                      bookCount:
                        multiDayDirectAcceptUsers || directAcceptUsers.length
                    }
            }}
          </ng-container>
          <ng-container *ngIf="suggestInsteadDirectAccept">
            {{
              "inviteAndSuggest"
                | i18n
                  : {
                      inviteCount: multiDayInviteUsers || selectedUsers.length,
                      bookCount:
                        multiDayDirectAcceptUsers || directAcceptUsers.length
                    }
            }}
          </ng-container>
        </span>
      </ng-container>
    </button>
  </div>
</form>
